import { messages as portugueseMessages } from "./pt";
import { messages as englishMessages } from "./en";
import { messages as spanishMessages } from "./es";
import { messages as turkishMessages } from "./tr"; // ✅ NOVO
import { messages as arabicMessages } from "./ar"; // ✅ NOVO

const messages = {
	pt: portugueseMessages.pt,
	en: englishMessages.en,
	es: spanishMessages.es,
	tr: turkishMessages.tr,
	ar: arabicMessages.ar,
};

export { messages };

